import React from "react";
import {useAppSelector} from "@/lib/hooks";
import {Link} from '@/i18n/navigation';
import {cn} from "@/lib/utils";
import AuthorizedHeader from "@/app/components/common/app-header/AuthorizedHeader";
import UnauthorizedHeader from "@/app/components/common/app-header/UnauthorizedHeader";
import Image from "next/image";

export default function AppHeader({className, ...props}: React.HTMLAttributes<HTMLDivElement>) {
    const isAuthorized = useAppSelector(state => !!state.auth.userId);

    return (
        <header
            className={cn(className, 'bg-dark-gray px-[16px] sm:px-[24px] md:px-[32px] pt-[16px] md:pt-[12px] pb-[12px] border-b-1 border-b-sidebar-border')} {...props}>
            <div className={'flex justify-between items-center h-[39px] md:h-[52px]'}>
                <Link prefetch={false} className={'mr-2.5'} href={'/'}>
                    <Image width={175} height={21} className={'active:scale-90 transition-transform duration-300'}
                           src={'/icons/logo.svg'} alt={'Logo'}/>
                </Link>
                {isAuthorized ? <AuthorizedHeader/> : <UnauthorizedHeader/>}
            </div>
        </header>
    )
}
